export default {
    yaopinzc: "中国药品注册",
    yaopincn: "中国上市药品",
    yizhixing: "仿制药一致性评价",
    yaopinus: "美国上市药品",
    yaopineu: "欧盟上市药品",
    yaopinjp: "日本上市药品",
    yaopinzb: "中国药品中标",
    yaopinsms: "药品说明书",
    yaopinbz: "药品标准",
    yibao: "中国医保目录",
    yaowu: "中国基本药物目录",
    cpsus: "美国橙皮书",
    cpsjp: "日本橙皮书",
    pqf: "中国生物制品批签发",
    zldj: "中国上市药品专利信息",
    zhengce: "医药政策",
    linchuang: "中国临床试验",
    linchuangus: "ClinicalTrials",
    qixiecn: "中国上市医疗器械",
    qixiefl: "医疗器械分类目录",
    qiye: "中国药品生产企业",
    qxqiye: "中国医疗器械生产企业",
    yljg: "医疗机构",
    yaopinzz: "药物杂质对照品",
    fuliao: "药用辅料",
    yuanfubao: "原辅包登记信息",
    yaopinhma: "欧盟HMA上市药品",
    zlsm: "中国上市药品专利信息",
    hcgy: "合成工艺",
    canbi: "仿制药参比制剂目录",
    drugreport: "药品报告",
    firmreport: "企业报告",
    data: "全球新药",
    cpszl: "橙皮书专利",
    api: "原料药",
    espatent: "医药专利数据",
    panorama: "中国药品研发历程全景图",
    yiyaozjt: "中间体数据库",
    patent: "专利数据",
    cpbs: "中国上市医疗器械",
    ylqxps: "中国医疗器械评审",
    cxyxqx: "医疗器械创新和优先审批",
    chictrdetail: "ChiCTR",
    ylqxbz: "医疗器械标准",
};
